import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Collapse, Button, CardBody, Card, CardTitle, FormGroup, Input, CardFooter, Label, Modal, ModalHeader, ModalBody, ModalFooter, Badge, Nav, NavItem, Breadcrumb, BreadcrumbItem, Alert } from 'reactstrap'
import Form from '../../../modules/Form'
import { FaExternalLinkAlt } from 'react-icons/fa'
import {
  getAppeal, saveForm, getAdminReasons
} from '../../../actions/adminActions'
import { withRouter } from 'react-router'
import FileUploadAdmin from '../../shared/_FileUploadAdmin'
import FileUploadAdminAdjudicator from '../../shared/_FileUploadAdminAdjudicator'

import RejectAccept from './_RejectAccept'
import Status from './_Status'
import Actions from './_Actions'
import Loading from '../../loading'
import PropTypes from 'prop-types'
// import { push } from 'connected-react-router'
import Moment from 'react-moment'
import TimeField from 'react-simple-timefield'

var moment = require('moment')

class AdminAppeal extends Component {
  constructor (props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.agToggle = this.agToggle.bind(this)
    this.adToggle = this.adToggle.bind(this)
    this.responseToggle = this.responseToggle.bind(this)
    this.modaltoggle = this.modaltoggle.bind(this)
    this.reasonChange = this.reasonChange.bind(this)

    this.state = {
      collapse: true,
      agCollapse: true,
      adCollapse: true,
      responseCollapse: false,
      selectedGrounds: '',
      today: moment().endOf('day'),
      modal: false,
      iagree: false,
      showOther: null

    }
    this.time = React.createRef(this.time)
    this.handleGroundsChange = this.handleGroundsChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.iagreeToggle = this.iagreeToggle.bind(this)
    this.onTimeChange = this.onTimeChange.bind(this)
  }

  componentDidMount () {
    // have to give text area contents afterwards
    this.props.getAppeal(this.props.match.params.appealID)
    this.props.getAdminReasons()
  }

  toggle () {
    this.setState({
      collapse: !this.state.collapse
      // agCollapse: false,
      // adCollapse: false,
    })
  }
  agToggle () {
    this.setState({
      agCollapse: !this.state.agCollapse
      // collapse: false,
      // adCollapse: false,
    })
  }
  adToggle () {
    this.setState({
      adCollapse: !this.state.adCollapse
      // agCollapse: false,
      // collapse: false,
    })
  }
  responseToggle () {
    this.setState({
      responseCollapse: !this.state.responseCollapse
    })
  }
  modaltoggle () {
    this.setState({
      modal: !this.state.modal
    })
  }
  reasonChange (e) {
    this.setState({ showOther: e.target.value === 'other' })
  }

  iagreeToggle () {
    this.setState({
      iagree: !this.state.iagree
    })
  }

  handleChange (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleGroundsChange (e) {
    this.setState({ selectedGrounds: e.target.value })
  }

  onTimeChange (time) {
    this.time.current.value = time
  }

  render () {
    let theChild

    if (this.props.admin.appeal.appealID && this.props.admin.reasons.length) {
      theChild =
        <div className='fade-in-on-enter'>
          <Container>
            <Row>
              <Col>
                <Breadcrumb>
                  <BreadcrumbItem><Link to='/admin'>Appeals</Link></BreadcrumbItem>
                  <BreadcrumbItem><Link to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>{this.props.admin.appeal.pcn}</Link></BreadcrumbItem>
                  <BreadcrumbItem active>Details</BreadcrumbItem>
                </Breadcrumb>
              </Col>
            </Row>
            <Row>
              <Col>
                <Nav fill tabs className='mb-3'>
                  <NavItem>
                    <Link className='nav-link active' to={`/admin/appeal/${this.props.admin.appeal.appealID}`}>Details</Link>
                  </NavItem>
                  <NavItem>
                    <Link className='nav-link' to={`/admin/appeal/${this.props.admin.appeal.appealID}/messaging`}>Messaging</Link>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col sm='12' md='8'>
                <Row>
                  <Col>
                    <Card>
                      <CardTitle onClick={this.toggle}>Driver and PCN Details <Badge color={this.props.admin.appeal.completed_driver_details ? 'success' : 'warning'}>{this.props.admin.appeal.completed_driver_details ? 'Appellant Completed' : 'Appellant To Do'}</Badge> <span className={this.state.collapse ? 'accordion-icon active' : 'accordion-icon'} /></CardTitle>
                      <Collapse isOpen={this.state.collapse}>
                        <CardBody>
                          <Form id='details' submit={this.props.saveForm}>

                            <div className='form-inline'>
                              <FormGroup >
                                <Input type='text' name='fname' defaultValue={this.props.admin.appeal.fname} id={'fname'} required placeholder='First Name' />
                                <div className='invalid-feedback' />
                              </FormGroup>

                              <FormGroup >
                                <Input type='text' name='lname' defaultValue={this.props.admin.appeal.lname} id={'lname'} required placeholder='Last Name' />
                                <div className='invalid-feedback' />
                              </FormGroup>

                      was driver of vehicle

                              <FormGroup >

                                <Input type='text' className='input-uppercase' name='reg' defaultValue={this.props.admin.appeal.reg} id={'reg'} required placeholder='Vehicle Registration' maxLength='8' />
                                <div className='invalid-feedback' />
                              </FormGroup>
                      .

                              <br />The Parking Charge Notice was issued on
                              <FormGroup >
                                <Input type='date' name='date' defaultValue={this.props.admin.appeal.date} id={'date'} required placeholder='Date' />
                                <div className='invalid-feedback' />
                              </FormGroup>
                              .
                              <br />The time of issue was
                              <FormGroup >
                                <TimeField
                                  value={this.props.admin.appeal.timeofissue || ''} // {String}   required, format '00:00' or '00:00:00'
                                  onChange={this.onTimeChange} // {Function} required
                                  input={<input type='text' className='form-control' />}
                                />
                                <input className='hidden' type='text' name='timeofissue' defaultValue={this.props.admin.appeal.timeofissue || null} id={'timeofissue'} ref={this.time} required />
                                <div className='invalid-feedback' />
                              </FormGroup>
                              .

                              <br />The reason for issue was:
                              <FormGroup>
                                <Input type='select' onChange={this.reasonChange} defaultValue={this.props.admin.appeal.reason} name='reason' id='reason' required>
                                  <option disabled selected value=''>Please select a reason</option>
                                  {this.props.admin.reasons.map((reason, index) => (
                                    <option key={index} value={reason.label}>{reason.reason}</option>
                                  ))}
                                </Input>
                                <div className='invalid-feedback' />
                              </FormGroup>
                              {((this.state.showOther === null && this.props.admin.appeal.reason === 'other') || this.state.showOther) &&
                                <FormGroup className='w-100 pr-5' >
                                  <Input type='text' className='w-100' name='reason_other' defaultValue={this.props.admin.appeal.reason_other} id={'reason_other'} required placeholder='Enter reason' />
                                  <div className='invalid-feedback' />
                                </FormGroup>
                              }
                              <hr />
                              <Row>
                                <Col xs='12' sm='6'>
                                  <p>Appellant Address:</p>
                                  <FormGroup >
                                    <Input type='text' name='address1' defaultValue={this.props.admin.appeal.address1} id={'address1'} required placeholder='Address 1' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                  <br />
                                  <FormGroup >
                                    <Input type='text' name='address2' defaultValue={this.props.admin.appeal.address2} id={'address2'} placeholder='Address 2' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                  <br />
                                  <FormGroup >
                                    <Input type='text' name='town' defaultValue={this.props.admin.appeal.town} id={'town'} required placeholder='Town' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                  <br />
                                  <FormGroup >
                                    <Input type='text' name='county' defaultValue={this.props.admin.appeal.county} id={'county'} required placeholder='County' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                  <br />
                                  <FormGroup >
                                    <Input type='text' name='postcode' defaultValue={this.props.admin.appeal.postcode} id={'postcode'} required placeholder='Postcode' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                </Col>
                                <Col xs='12' sm='6'>
                                  <p>Appellant phone and email:</p>
                                  <FormGroup >
                                    <Input type='text' name='phone' defaultValue={this.props.admin.appeal.phone} id={'phone'} placeholder='Phone number' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                  <br />
                                  <FormGroup >
                                    <Input type='email' name='email' defaultValue={this.props.admin.appeal.email} id={'email'} placeholder='Email' />
                                    <div className='invalid-feedback' />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>

                          </Form>
                        </CardBody>
                        <CardFooter>
                          <Button color='primary' form='details' disabled={this.props.admin.appeal.details_loading}>Update on behalf of appellant <span className='spinning' /></Button>
                        </CardFooter>
                      </Collapse>
                    </Card>

                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Card>
                      <CardTitle onClick={this.agToggle}>Appeal Grounds <Badge color={this.props.admin.appeal.completed_appeal_grounds ? 'success' : 'warning'}>{this.props.admin.appeal.completed_appeal_grounds ? 'Appellant Completed' : 'Appellant To Do'}</Badge> <span className={this.state.agCollapse ? 'accordion-icon active' : 'accordion-icon'} /></CardTitle>
                      <Collapse isOpen={this.state.agCollapse}>
                        <CardBody>
                          <Form id='grounds' submit={this.props.saveForm}>

                            <FormGroup tag='fieldset'>
                              <legend>Appellant's grounds for this appeal</legend>
                              <FormGroup check>
                                <Label check>
                                  <Input type='radio' id='grounds1' value={1} name='grounds' defaultChecked={this.props.admin.appeal.grounds === '1'} onChange={this.handleGroundsChange} required />
                        Parking charge was correctly issued but would like to appeal on mitigating circumstances

                                </Label>
                              </FormGroup>
                              <br />
                              <FormGroup check>
                                <Label check>
                                  <Input type='radio' id='grounds2' value={2} name='grounds' defaultChecked={this.props.admin.appeal.grounds === '2'} onChange={this.handleGroundsChange} required />
                        Appeal against the parking charge as it was incorrectly issued
                                  <div className='invalid-feedback' />

                                </Label>

                              </FormGroup>

                            </FormGroup>

                          </Form>
                        </CardBody>
                        <CardFooter>
                          <Button color='primary' form='grounds' disabled={this.props.admin.appeal.grounds_loading}>Update on behalf of appellant <span className='spinning' /></Button>
                        </CardFooter>
                      </Collapse>
                    </Card>

                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Card>
                      <CardTitle onClick={this.adToggle}>Appeal Detail <Badge color={this.props.admin.appeal.completed_appeal_detail ? 'success' : 'warning'}>{this.props.admin.appeal.completed_appeal_detail ? 'Appellant Completed' : 'Appellant To Do'}</Badge> <span className={this.state.adCollapse ? 'accordion-icon active' : 'accordion-icon'} /></CardTitle>
                      <Collapse isOpen={this.state.adCollapse}>
                        <CardBody>
                          <Form id='appealDetail' submit={this.props.saveForm}>
                            <FormGroup >
                              <Input type='textarea' name='detail' id={'detail'} defaultValue={this.props.admin.appeal.detail} />
                            </FormGroup>

                          </Form>
                        </CardBody>
                        <CardFooter>
                          <Button color='primary' form='appealDetail' disabled={this.props.admin.appeal.appealDetail_loading}>Update on behalf of appellant <span className='spinning' /></Button>
                        </CardFooter>
                      </Collapse>
                    </Card>

                  </Col>
                </Row>
              </Col>
              <Col sm='12' md='4'>
                {this.props.admin.appeal.submittedDate &&
                <Alert color='info'>
                  <p>Appeal was submitted on <b><Moment format='dddd Do MMMM'>{this.props.admin.appeal.submittedDate}</Moment></b></p>
                </Alert>
                }
                {this.props.expired && !this.props.admin.appeal.submittedDate &&
                <Alert color='danger'>
                  <p>Appeal was not completed, declared and submitted within 21 days of the issue date.</p>
                </Alert>
                }
                {!this.props.admin.appeal.submittedDate && !this.props.expired &&
                <Alert color='warning'>
                Appelant has <b><Moment ago to={moment(this.props.admin.appeal.submitby).endOf('day')}>{moment()}</Moment> left</b> to complete, declare and submit appeal (before the end of the day on <b> <Moment format='dddd Do MMMM'>{this.props.admin.appeal.submitby}</Moment></b>).
                </Alert>
                }
                <hr />
                <RejectAccept status={this.props.admin.appeal.status} />
                <hr />
                <Status />
                <hr />
                <Actions />
                <hr />
                <FileUploadAdmin />
                <FileUploadAdminAdjudicator />
                <hr />
                <Link className='btn btn-secondary btn-block mb-5' target='_blank' to={`/appeal/${this.props.admin.appeal.appealID}`}><FaExternalLinkAlt /> Login as appellant in new window</Link>
              </Col>
            </Row>
            <Modal isOpen={this.state.modal} toggle={this.modaltoggle}>
              <ModalHeader toggle={this.modaltoggle}>{this.props.admin.appeal.submittedDate ? 'Appeal Submitted' : 'Warning'}</ModalHeader>
              <ModalBody>
                {!this.props.admin.appeal.submittedDate &&
                <div>
                  <p>As driver of the vehicle you are about to submit your appeal forward for adjudication.</p>
                  <p>Once submitted you will no longer be able add any further details and your appeal will be adjudicated on the information you have provided only.</p>
                  <p>Upon pressing submit you agree that the information your have provided to be truthful and accurate and that you understand that providing false information may lead to your appeal being ended and any discounted period ending.</p>
                  <p>You agree to the processing of your personal data in accordance with our personal data <a target='_blank' href='/privacy-statement'>privacy statement</a>.</p>
                  <FormGroup check>
                    <Label check>
                      <Input type='checkbox' id='declaration' name='declaration' onChange={this.iagreeToggle} />
                        Tick to agree
                    </Label>
                  </FormGroup>
                </div>
                }
                {this.props.admin.appeal.submittedDate &&
                <div>
                  <p>Your appeal has now been submitted.</p>
                  <p>Please allow 14 working days for your appeal to be processed.</p>
                </div>
                }

              </ModalBody>
              <ModalFooter>
                {!this.props.admin.appeal.submittedDate &&
                <div>
                  <Button color='secondary' onClick={this.modaltoggle}>Cancel</Button>
                  <Button color='primary' onClick={this.props.declareAndSubmit} disabled={(!(this.state.iagree) || this.props.admin.appeal.dands_loading)} >Declaration and Submit</Button>
                </div>}
                {this.props.admin.appeal.submittedDate &&
                <Button color='primary' onClick={this.props.logOut} >Log out</Button>
                }
              </ModalFooter>
            </Modal>

          </Container>
        </div>
    } else {
      theChild = <Loading />
    }

    return (
      <div>
        {theChild}
      </div>
    )
  }
};

AdminAppeal.propTypes = {
  getAppeal: PropTypes.func,
  admin: PropTypes.object,
  match: PropTypes.object,
  saveForm: PropTypes.func,
  declareAndSubmit: PropTypes.func,
  logOut: PropTypes.func,
  expired: PropTypes.bool,
  getAdminReasons: PropTypes.func
  // goTo: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin,
  expired: moment(admin.appeal.submitby).add(1, 'days').isBefore(moment(new Date(), 'day'))

})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      // changePage: () => push('/about-us'),
      getAppeal,
      saveForm,
      getAdminReasons
      // goTo: (path) => push(path)

    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminAppeal))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/AdminAppeal.jsx